import type { Product } from '../types/product';

export const categorizeProducts = (products: Product[]) => {
  const productsArray = products.filter(({ type }) => type === 'product') ?? [];

  const categoriesArray =
    products.filter(({ type }) => type === 'category') ?? [];

  return {
    products: productsArray,
    categories: categoriesArray,
  };
};
